import { jsx as _jsx } from "react/jsx-runtime";
import { defineMessages, useIntl } from "react-intl";
import { DployTable } from "../DployTable";
const EquityStatus = (props) => {
    const intl = useIntl();
    const cellStyle = { fontSize: 13 };
    const messages = defineMessages({
        title: {
            id: "core.equitystatus.equity",
            defaultMessage: "Equity"
        },
        received: {
            id: "core.equitystatus.received",
            defaultMessage: "Received"
        },
    });
    const data = {
        equity: intl.formatMessage(messages.title),
        received: props.equityStatus === 1
    };
    return (_jsx(DployTable, { title: "", columns: [
            {
                title: "",
                field: "equity",
                cellStyle
            },
            {
                title: intl.formatMessage(messages.received),
                field: "received",
                type: "boolean",
                align: "right",
                cellStyle
            },
        ], data: [data], options: {
            search: false,
            draggable: false,
            sorting: false,
            headerStyle: cellStyle,
            paging: false,
            showEmptyDataSourceMessage: false,
            emptyRowsWhenPaging: false,
            header: true,
        } }));
};
export { EquityStatus };
//# sourceMappingURL=EquityStatus.js.map